 const origin = window.location.origin;
  const pathname = window.location.pathname;

  if(pathname === '/') {
    $(`a[href*="${origin}/#"]`).not('[data-lity]').click(function(e) {
      const hash = $.attr(this, 'href').split('#')[1];
      if(hash) {
        e.preventDefault();
        $('html, body').animate(
          {
            scrollTop: $(`#${hash}`).offset().top
          },
          800
        );
        return false;
      }
    });
  }

jQuery(document).ready(function($) {
    // Wait for the document to be ready
    $(".utility-bar .close").click(function() {
        // Toggle the visibility of the content
        $(".utility-bar").hide();
    });
});

// GS20
document.addEventListener('DOMContentLoaded', function () {
  function handleClick() {
    // Targeting (X button) element 
    var summaryElement = document.querySelector('.header__icon.header__icon--menu.header__icon--summary.link.focus-inset[aria-label="Menu"][role="button"][aria-expanded="true"][aria-controls="menu-drawer"]');

    if (summaryElement instanceof HTMLElement) {
      summaryElement.click();
    } else {
      console.error('Element with the specified attributes not found or not a valid HTML element.');
    }
  }

  function addClickListeners() {
    var joinTheClubElement = document.getElementById('HeaderDrawer-join-the-club');
    var navLogoImage = document.getElementById('gs20-scrollFix');

    if (joinTheClubElement) {
      joinTheClubElement.addEventListener('click', handleClick);
    } else {
      console.error('Element with ID "HeaderDrawer-join-the-club" not found.');
    }

    if (navLogoImage) {
      navLogoImage.addEventListener('click', function(event) {
        event.preventDefault();
        handleClick();

        setTimeout(function() {
          window.location.href = navLogoImage.getAttribute('href');
        }, 300); // Adjust the delay as needed
      });
    } else {
      console.error('Element with ID "gs20-scrollFix" not found.');
    }
  }

  function waitForElementToLoad() {
    var intervalId = setInterval(function () {
      var joinTheClubElement = document.getElementById('HeaderDrawer-join-the-club');
      var navLogoImage = document.getElementById('gs20-scrollFix');

      if (joinTheClubElement && navLogoImage) {
        clearInterval(intervalId); // Stop checking once both elements are found
        addClickListeners();
      }
    }, 100);
  }

  waitForElementToLoad();
});

// GS20 (testing custom events)
document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("Details-menu-drawer-container").addEventListener("click", function() {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({
      event: "Hamburger menu clicked"
    });
  });
});

// GS19 
document.addEventListener('DOMContentLoaded', function() {
  var exitButton = document.getElementById('button-exit');
  if (exitButton) {
    exitButton.addEventListener('click', function handleClick() {
      // Check if the warning message div already exists
      if (!document.getElementById('age-warning')) {
        // Create the warning message div
        var warningDiv = document.createElement('div');
        warningDiv.id = 'age-warning';
        warningDiv.style.color = 'red';
        warningDiv.style.marginBottom = '20px';
        warningDiv.style.display = 'block';
        warningDiv.style.fontWeight = 'bold';
        warningDiv.textContent = "You can't enter without confirming you are over 18.";

        // Append the warning message div after the specific span
        var paragraph = document.querySelector('#age-check-prompt span p');
        paragraph.parentNode.appendChild(warningDiv);
      }

      // Remove the href attribute from the button
      document.getElementById('button-exit').removeAttribute('href');

      // Disable the button after it's clicked
      document.getElementById('button-exit').removeEventListener('click', handleClick);
    });
  }
});

// GS27
document.addEventListener('DOMContentLoaded', function() {
  function updateCountdown() {
    var now = new Date();
    
    // Calculate the first day of the next month
    var nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    
    // Calculate the difference in milliseconds
    var timeLeft = nextMonth - now;
    
    // Calculate the days, hours, and minutes left
    var daysLeft = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    var hoursLeft = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    
    // Update the countdown display
    document.getElementById('gs27-countdown').innerHTML =
      daysLeft + " days : " + hoursLeft + " hours : " + minutesLeft + " minutes";
    
    // Repeat the function every minute
    setTimeout(updateCountdown, 60000);  // 60000 milliseconds = 1 minute
  }
  
  updateCountdown();
});

// Fix for nav item "JOIN THE CLUB!" braking the scroll
document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('HeaderDrawer-purchase-today').addEventListener('click', function () {
    // Target the specific <summary> element with the given class names
    var summaryElement = document.querySelector('.header__icon.header__icon--menu.header__icon--summary.link.focus-inset[aria-label="Menu"][role="button"][aria-expanded="true"][aria-controls="menu-drawer"]');

    if (summaryElement instanceof HTMLElement) {
      summaryElement.click();
    } else {
      console.error('Element with the specified attributes not found or not a valid HTML element.');
    }
  });
});

// GS PDP Redesign
document.addEventListener('DOMContentLoaded', function () {
  function simulateClickOnSecondLi() {
    const ulElement = document.querySelector('.thumbnail-list.slider.slider--mobile');

    if (ulElement) {
      const secondLi = ulElement.querySelector('li:nth-child(2)');
      if (secondLi) {
        const button = secondLi.querySelector('button');

        if (button) {
          button.click();
        } else {
          console.error('Button not found in the second li element.');
        }
      } else {
        console.error('Second li element not found.');
      }
    } else {
      console.error('Parent ul element not found.');
    }
  }

  simulateClickOnSecondLi();
});

// GS03 V2 - Dynamic cart button price updates
(function () {
  function initGS03() {
    const container = document.getElementById('gs03-v2');
    if (!container) return;

    // Find the button - it's now in the parent form, not inside gs03-v2
    const form = container.closest('form');
    const cartButton = form ? form.querySelector('[data-gs03-cart-button]') : null;
    const upsellCard = container.querySelector('.gs03-upsell-card');

    if (!cartButton || !upsellCard) return;

    const states = {
      regular: { compare: '$230+', current: '$99' },
      deluxe: { compare: '$260+', current: '$129' },
    };

    function ensureStructure() {
      let textWrapper = cartButton.querySelector('.text');
      if (!textWrapper) {
        textWrapper = document.createElement('span');
        textWrapper.className = 'text';
        cartButton.appendChild(textWrapper);
      }
      if (
        !textWrapper.querySelector('.gs03-cart-price__compare') ||
        !textWrapper.querySelector('.gs03-cart-price__current')
      ) {
        textWrapper.innerHTML = `
          <span class="gs03-cart-label">ADD TO CART</span>
          <span class="gs03-cart-divider"> - </span>
          <span class="gs03-cart-price">
            <span class="gs03-cart-price__compare">$230+</span>
            <span class="gs03-cart-price__current">$99</span>
          </span>
        `;
      }
      return {
        compareNode: textWrapper.querySelector('.gs03-cart-price__compare'),
        currentNode: textWrapper.querySelector('.gs03-cart-price__current'),
      };
    }

    function applyState(isDeluxe) {
      const nodes = ensureStructure();
      if (!nodes.compareNode || !nodes.currentNode) return;

      const state = isDeluxe ? states.deluxe : states.regular;
      nodes.compareNode.textContent = state.compare;
      nodes.currentNode.textContent = state.current;
    }

    function initState() {
      const isDeluxe = upsellCard.classList.contains('is-active');
      applyState(isDeluxe);
    }

    // Observe changes (Loop may rewrite button content)
    const observer = new MutationObserver(() => {
      const textWrapper = cartButton.querySelector('.text');
      if (textWrapper && !textWrapper.querySelector('.gs03-cart-price__compare')) {
        initState();
      }
    });

    observer.observe(cartButton, { childList: true, subtree: true });

    // Listen for upsell toggle events (bubbles from container)
    document.addEventListener('gs03:upsell-toggle', (e) => {
      if (!e?.detail) return;
      // Only process if it came from our container
      const targetContainer = e.target.closest('#gs03-v2');
      if (targetContainer === container) {
        applyState(Boolean(e.detail.selected));
      }
    });

    // Retry initialization with requestAnimationFrame for dynamic content
    let retries = 0;
    function retryInit() {
      initState();
      if (retries++ < 20) {
        requestAnimationFrame(retryInit);
      }
    }

    retryInit();
  }

  // Safe initialization for IG
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGS03);
  } else {
    initGS03();
  }
})();